import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ordersApi } from '../api';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Package, Loader2, ChevronRight } from 'lucide-react';

const formatMoney = (amount) => new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN', minimumFractionDigits: 0 }).format(amount);
const formatDate = (date) => new Date(date).toLocaleDateString('en-NG', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => { fetchOrders(); }, []);

  const fetchOrders = async () => {
    try {
      const response = await ordersApi.getAll();
      setOrders(response.data);
    } catch (error) {
      console.error('Failed to fetch orders:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) return <div className="flex justify-center py-12"><Loader2 className="w-8 h-8 animate-spin text-[#FFD700]" /></div>;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-white font-['Outfit']">My Orders</h1>
      {orders.length === 0 ? (
        <div className="text-center py-12">
          <Package className="w-16 h-16 mx-auto text-zinc-600 mb-4" />
          <h2 className="text-xl font-semibold text-white mb-2">No orders yet</h2>
          <p className="text-zinc-400">Your order history will appear here.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((order) => (
            <Link key={order.id} to={`/orders/${order.id}`} data-testid={`order-${order.id}`}>
              <Card className="bg-[#0A0A0A] border-white/10 hover:border-[#FFD700]/30 transition-colors">
                <CardContent className="p-4 flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-[#121212] rounded-lg flex items-center justify-center"><Package className="w-6 h-6 text-[#FFD700]" /></div>
                    <div>
                      <p className="font-semibold text-white">Order #{order.id.slice(0, 8)}</p>
                      <p className="text-sm text-zinc-500">{formatDate(order.created_at)} · {order.items_count} item(s)</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="text-right">
                      <p className="font-bold text-[#FFD700]">{formatMoney(order.total_amount)}</p>
                      <Badge variant="outline" className={order.status === 'completed' ? 'border-green-500/30 text-green-500' : 'border-yellow-500/30 text-yellow-500'}>{order.status}</Badge>
                    </div>
                    <ChevronRight className="w-5 h-5 text-zinc-500" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
